import { Api, ApiMethod } from "../components/common/ApiLinkedButton";
import { ContentConstants } from "./Content.Constants";
import { ContentItem } from "./Content.model";

export class ContentApi {
  public static getCi(ciId: string): Api<void, ContentItem> {
    return new Api<void, ContentItem>(
      ContentConstants.CONTENT_ITEM_SINGLE.replaceAll("{ciId}", ciId),
      ApiMethod.GET
    );
  }
}
